export const ISO_TILE_W = 64;
export const ISO_TILE_H = 32;
export const ELEVATION_PIXEL_OFFSET = 16;
/**
 * Convert a cartesian tile coordinate to the top-center of its iso diamond.
 * The map-height x offset keeps tile (0, mapHeight - 1) at non-negative x.
 */
export function toScreen(tx, ty, mapHeight, elevation = 0) {
    const halfW = ISO_TILE_W / 2;
    const halfH = ISO_TILE_H / 2;
    return {
        x: (tx - ty) * halfW + mapHeight * halfW,
        y: (tx + ty) * halfH - elevation * ELEVATION_PIXEL_OFFSET,
    };
}
/**
 * Convert an iso screen-space point on the tile plane to fractional cartesian
 * tile coordinates. Callers can floor the result for tile indices.
 */
export function screenToTile(screenX, screenY, mapHeight, elevation = 0) {
    const halfW = ISO_TILE_W / 2;
    const halfH = ISO_TILE_H / 2;
    const adjustedY = screenY + elevation * ELEVATION_PIXEL_OFFSET;
    const a = (screenX - mapHeight * halfW) / halfW;
    const b = adjustedY / halfH;
    return {
        tx: (a + b) / 2,
        ty: (b - a) / 2,
    };
}
export function isoDepth(tx, ty, layerOffset = 0) {
    return (tx + ty) * 10 + layerOffset;
}
export function isoWorldBounds(mapWidth, mapHeight) {
    return {
        width: (mapWidth + mapHeight) * (ISO_TILE_W / 2),
        height: (mapWidth + mapHeight) * (ISO_TILE_H / 2),
    };
}
//# sourceMappingURL=coordinates.js.map